import React from 'react';
import { twMerge } from 'tailwind-merge';

const SectionTitle = ({ id, resp, className, color, css, descrCSS, titleCSS, titleGradient, layout, ...props }) => {

  switch (layout) {
    case 'left': css = ''; break
    case 'center': css = 'items-center justify-center'; /* titleCSS="text-center" */; break
    case 'text': css = 'text-center items-center'; break
    default: css = 'text-left '; break
  }


  return (
    <div
      // TODO : CHECK MOTION DIV TO REMAIN ACTIVE OR REMOVED
      // initial={{ opacity: 0 }}
      // animate={{ opacity: 1 }}
      // whileInView={{ opacity: 1 }}
      // transition={transition}
      // viewport={{ once: true, amount: 'some' }}
      className={twMerge('relative flex flex-col h-fit gap-5 w-full', resp && "resp", color === 'switch' && '!text-blakk',
        className, css || '',
      )}>

      {props.subtitle && (
        <p className='relative flex items-center py-2 rounded-lg w-fit min-h-6 !font-arial !text-white text-sm uppercase whitespace-nowrap'>
          {props.subtitle || 'a subtitle'}
          <span className='brightness-125 absolute inset-0 bg-primary/20 rounded-lg translate-x-1 translate-y-2' />
        </p>
      )}

      <h2 style={titleGradient && { background: 'linear-gradient(90deg, #F47298 0%, #E4E1E5 61.98%, #E4E4E7 100%)' }}
        className={`font-poppins max-w-[20ch] leading-tight ${titleCSS} ${titleGradient && '!text-transparent !bg-clip-text'} `}>
        <span
          // initial={{ y: -100, opacity: 0 }}
          // animate={{ y: 0, opacity: 1, transition: { ease, duration } }}
          // viewport={{ once: true, }}
          className='pb-2 select-none'
        >
          {props.title || 'This is a title'}
        </span>
      </h2>

      {props.descr && (
        <h4 style={{}} className={twMerge('dim lg:w-1/2 select-none', descrCSS)}><span>{props.descr}</span>
        </h4>
      )}

    </div>
  )
}

export default SectionTitle
